export default __webpack_public_path__ + "static/avatar2-8dbe6cecbefd383535c9c8f45d87eeef.png";